<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible="visible"
    width="500px"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => close()"
    append-to-body
    v-el-dialog-drag
    @submit.native.prevent
  >
    <el-form ref="form" :model="formData" size="small" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_factoryOrderNo') || '工厂订单编号'"
            prop="factoryOrderNo"
          >
            <el-input
              v-model.trim="formData.factoryOrderNo"
              :placeholder="
                $l('tips_input_factoryOrderNo') || '请输入工厂订单编号'
              "
              :maxlength="50"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="close">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>

      <el-button size="small" type="primary" @click="batchUpdate">
        {{ $l('form_label_person_batch_updates') || '更新' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import validate from '@/libs/util.validate'

export default {
  mixins: [EditLoading],
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '更新工厂订单编号' },
    factoryOrderNo: { type: String, default: '' },
  },
  data() {
    return {
      formData: { factoryOrderNo: '' },
      rules: {
        factoryOrderNo: [
          {
            required: true,
            message:
              this.$l('tips_input_factoryOrderNo') || '请输入工厂订单编号...',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  watch: {
    factoryOrderNo: {
      handler() {
        this.formData.factoryOrderNo = this.factoryOrderNo || ''
      },
      immediate: true,
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    async batchUpdate() {
      this.formData.factoryOrderNo = `${this.formData.factoryOrderNo || ''}`.trim()
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      this.$emit('confirm', this.formData)
    },
  },
}
</script>
<style lang="scss" scoped></style>
